import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import { FaChevronDown } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';

const Header = ({ style }) => {
  const location = useLocation();
  const { isLoggedIn } = useAuth();

  return (
    <header className="main-header" style={style}>
      <div className="header-container">
        <Link to="/" className="header-logo-link">
          Rias Baixas PD
        </Link>
        <nav className="header-nav">
          <ul className="nav-list">
            <li className="nav-item has-dropdown">
              <Link to="/" className={`nav-link dropdown-trigger ${location.pathname === '/' || location.pathname === '/mas-informacion' || (location.pathname === '/dashboard' && (new URLSearchParams(location.search).get('tab') === 'galeria' || new URLSearchParams(location.search).get('tab') === 'valoraciones')) ? 'active' : ''}`}>
                Inicio <FaChevronDown className="dropdown-arrow" />
              </Link>
              <ul className="dropdown-menu">
                <li>
                  <Link to="/" className={location.pathname === '/' ? 'active-sub' : ''}>
                    Página Principal
                  </Link>
                </li>

                <li>
                  <Link to="/mas-informacion" className={location.pathname === '/mas-informacion' ? 'active-sub' : ''}>
                    Más información
                  </Link>
                </li>

                <li>
                  <Link to="/dashboard?tab=galeria&from=inicio" className={location.pathname === '/dashboard' && new URLSearchParams(location.search).get('tab') === 'galeria' ? 'active-sub' : ''}>
                    Galería
                  </Link>
                </li>

                <li>
                  <Link to="/dashboard?tab=valoraciones&from=inicio" className={location.pathname === '/dashboard' && new URLSearchParams(location.search).get('tab') === 'valoraciones' ? 'active-sub' : ''}>
                    Valoraciones
                  </Link>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <Link to="/como-conectarse" className={`nav-link ${location.pathname === '/como-conectarse' ? 'active' : ''}`}>
                Cómo Conectarse
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/whitelist" className={`nav-link ${location.pathname === '/whitelist' ? 'active' : ''}`}>
                Whitelist
              </Link>
            </li>
            {/* Botón de Normativa como enlace interno en la nav */}
            <li className="nav-item">
              <Link to="/normativa" className={`nav-link normativa-link ${location.pathname === '/normativa' ? 'active' : ''}`}>
                Normativa
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/tienda" className={`nav-link ${location.pathname === '/tienda' ? 'active' : ''}`}>
                Tienda
              </Link>
            </li>
            {isLoggedIn ? (
              <li className="nav-item">
                <Link to="/dashboard" className={`nav-link ${location.pathname === '/dashboard' && !new URLSearchParams(location.search).get('tab') ? 'active' : ''}`}>
                  Mi Perfil
                </Link>
              </li>
            ) : (
              <li className="nav-item">
                <Link to="/login" className={`nav-link ${location.pathname === '/login' ? 'active' : ''}`}>
                  Iniciar Sesión
                </Link>
              </li>
            )}
          </ul>
        </nav>
        <div className="discord-button-container" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          {/* Botón de Discord fijo */}
          <a href="https://discord.gg/GXr37Wr8CJ" target="_blank" rel="noopener noreferrer" className="discord-button">
            Únete a Discord
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;